import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockFormsFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy: the field-type map pulls libphonenumber-js (~38kB gzip) for phone
 * validation. A static import here put that in every app's eager entry chunk
 * regardless of whether any page rendered a form.
 */
export const formsBlockConfig = {
  name: 'inner-block-forms',
  component: defineAsyncComponent(() => import('./CmsFormsBlock.vue')),
  fields: blockFormsFields,
} satisfies ModularBlockConfig;
